

export const formatNumberWithCommas = (inn, decimalPlaces = 0) => {
  let end = "";
  let num = inn;
  if (inn == 0 || inn == null) {
    return "0";
  }
  if (String(inn).endsWith("ml")) {
    end = "ml";
    inn.replace("ml", "");
    num = inn;
  }
  if (String(inn).endsWith("L")) {
    end = "L";
    inn.replace("L", "");
    num = inn;
  }
  if (String(inn).endsWith("kg")) {
    end = "kg";
    inn.replace("kg", "");
    num = inn;
  }
  if (String(inn).endsWith("g")) {
    end = "g";
    inn.replace("g", "");
    num = inn;
  }

  const number = parseFloat(num);
  const fixedNumber =
    decimalPlaces > 0
      ? number.toFixed(decimalPlaces)
      : Math.round(number).toString();

  const parts = fixedNumber.split(".");
  let integerPart = parts[0];
  const decimalPart = parts.length > 1 ? `.${parts[1]}` : "";

  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return integerPart + decimalPart + end;
};



export const isDeviceManager = function(device, user_id) {
	let managerIds = []
	if(device.headers && device.headers.length>0) {
		let ids = device.headers.map((user) => {
			return user.id
		})
		managerIds.push(...ids)
	}
	if(device.contacts && device.contacts.length>0) {
		let ids = device.contacts.map((user) => {
			return user.id
		})
		managerIds.push(...ids)
	}
	
	let isManager = managerIds.indexOf(user_id)>=0 ? true : false
  console.log('isDeviceManager ===>', managerIds, user_id)
	console.log('isDeviceManager ===>', isManager)
	return isManager
}

